import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getLeague } from '../../data';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Select, MenuItem, Button, Typography } from '@material-ui/core';

class AllTeams extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            teams: [],
            loading: true,
            leagueID: this.props.match.params.leagueID,
            leagueName: undefined,
        };
        this.handleGameWeekChange = this.handleGameWeekChange.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        this.setState(() => ({
            ...this.state,
            serverError: undefined,
            loading: true,
            teams: [],
            leagueID: nextProps.match.params.leagueID,
            status: 'drafting',
        }));
        const t = this;
        setTimeout(t.loadData, 1);
    }

    async loadData() {
        const state = this.state;
        const data = await getLeague(state.leagueID);
        this.setState(() => ({
            ...this.state,
            teams: data['teams'],
            isAdmin: data['isAdmin'],
            tournament: data['tournament'],
            status: data['status'],
            leagueName: data['name'],
            loading: false,
            gameWeekIndex: 1,
        }))
    }

    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type) {
            this.setState(() => ({
                loading: true,
            }))
            const t = this;
            setTimeout(t.loadData, 1);
        }
    }

    handleGameWeekChange(e) {
        const gw = e.target.value;
        const gameWeekNumber = parseInt(gw.split('GW')[1]);
        const numGameWeeks = this.state.teams[0]['scores'].length;
        const index = numGameWeeks - gameWeekNumber;
        this.setState(() => ({
            ...this.state,
            gameWeek: gw,
            gameWeekIndex: index,
        }));
    }

    render() {
        const headers = [];
        if (this.state.teams.length === 0) {
            headers.push('...');
            headers.push('...');
        } else if (this.state.status === 'playing') {
            const numGameWeeks = this.state.teams[0]['scores'].length;
            headers.push(`GW${numGameWeeks}`);
            const menuOptions = [];
            for (var i = numGameWeeks - 1;i > 0;i--) {
                menuOptions.push(`GW${i}`);
            }
            if (menuOptions.length > 0) {
                const selectGameWeek = (
                    <Select id='gameweek' value={this.state.gameWeek || `GW${numGameWeeks - 1}`} onChange={this.handleGameWeekChange}>
                        {menuOptions.map(gw => {
                            return <MenuItem key={gw} value={gw}>{gw}</MenuItem>
                        })}
                    </Select>
                )
                headers.push(selectGameWeek);
            }
        }
        return (
            <div style={{ 'display': 'flex', 'justifyContent': 'center', flexWrap: 'wrap', marginBottom: '50px' }}>
                {this.state.tournament !== undefined &&
                <div style={{display: 'flex-item', flexBasis: '100%', marginBottom: 20}}>
                <Link to={`/players/${this.state.tournament}/${this.state.leagueID}`} style={{width: 200}}>
                    <Button variant='contained'>
                        Players
                    </Button>
                </Link>
                {this.state.isAdmin && 
                <Link to={`/leagues/${this.state.leagueID}/admin`} style={{width: 200, marginLeft: 20}}>
                    <Button variant='contained'>
                        League Admin
                    </Button>
                </Link>
                }
                {this.state.isAdmin && 
                <Link to={`/leagues/${this.state.leagueID}/settings`} style={{width: 200, marginLeft: 20}}>
                    <Button variant='contained'>
                        League Settings
                    </Button>
                </Link>
                }
                </div>}
                <TableContainer component={Paper} style={{ 'maxWidth': '600px', display: 'flex-item', }}>
                    {this.state.loading && (
                        <div>
                            <CircularProgress />
                            <br />
                        </div>
                    )}
                    {(this.state.leagueName !== undefined) &&
                        <Typography variant="h6">
                            {this.state.leagueName}
                        </Typography>
                    }
                    {this.state.status === 'playing' &&
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell>Rank</TableCell>
                                <TableCell>Team</TableCell>
                                <TableCell>Captains</TableCell>
                                <TableCell>Total</TableCell>
                                <TableCell>{headers[0]}</TableCell>
                                <TableCell>{headers[1]}</TableCell>
                            </TableRow>
                            {this.state.teams.map((team, i) => (
                                <TableRow key={team.name}>
                                    <TableCell>
                                        {i + 1}
                                    </TableCell>
                                    <TableCell>
                                        <Link to={`/leagues/${this.state.leagueID}/teams/${team.name}`}>
                                            {team.name}
                                        </Link>
                                    </TableCell>
                                    <TableCell>{team.captainsUsed}</TableCell>
                                    <TableCell>{team.totalScore.toFixed(2)}</TableCell>
                                    <TableCell>{team.scores[0]}</TableCell>
                                    <TableCell>{team.scores[this.state.gameWeekIndex]}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    }
                    {this.state.status !== 'playing' &&
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell>Team</TableCell>
                            </TableRow>
                            {this.state.teams.map((team, i) => (
                                    <TableRow key={team.name}>
                                        <TableCell>
                                            <Link to={`/leagues/${this.state.leagueID}/teams/${team.name}`}>
                                                {team.name}
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    }
                </TableContainer>
            </div>
        );
    }
}
export default withRouter(AllTeams);